// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"26":"f1315a37ded38211","888":"5ecf5e6f5fc0b484"}[chunkId] + ".css";
};